module.exports = __webpack_public_path__ + "static/media/8-item-b.3917b8d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/8-item-b.jpg
// module id = 1212
// module chunks = 33